<div *ngIf="showLoginLoader">
	<div class="loader-bg"></div>
	<div class="loader-div">
		<div class="loader circle-loader-2"></div>
	</div>
</div>

<div class="o-block u-text-center u-fullscreen u-overflow-auto u-bg-muted">
	<div class="o-block__cell u-flex u-flexGrow-1 u-mb-medium u-p-big">
		<div class="reset-password-message">{{ resetPasswordMessage }}</div>
		<div class="u-m-auto" *ngIf="!showPasswordResetForm">
			<div
				class="c-formCard o-block u-collapse u-bg-main u-shadow-medium u-p-medium u-pt-none _u-width-100p _u-mb-small"
			>
				<div class="o-block__cell">
					<span class="c-formCard__icon c-button c-button--big c-button--icon u-radius-circle u-font-huge"
						><i class="fa fa-unlock-alt" aria-hidden="true" style="font-size: 2em"></i
					></span>
				</div>
				<div class="o-block__cell">
					<h2 class="u-font-regular loginTitle">Login</h2>
				</div>
				<form>
					<div class="o-block__cell" id="container_userId" *ngIf="showSSOUserEmailSection">
						<div class="c-control u-width-100p">
							<div class="c-control__input-box">
								<input
									class="c-control__input"
									name="userid"
									type="text"
									placeholder="Your Email"
									autocomplete="off"
									id="username"
									required="required"
									[(ngModel)]="username"
								/>
							</div>
							<span class="c-icon c-icon-main">
								<i class="fa fa-envelope" aria-hidden="true" title="{{ usernameTip }}"></i>
							</span>
						</div>
						<div class="o-block__cell">
							<button class="c-button c-button--block" (click)="validateApiLoginUserid()" style="margin-top: 20px">
								<span>Login</span>
							</button>
						</div>
					</div>

					<div class="o-block__cell" id="container_password" *ngIf="!showSSOUserEmailSection">
						<div class="c-control u-width-100p">
							<div class="c-control__input-box">
								<input
									class="c-control__input"
									name="password"
									type="password"
									placeholder="Password"
									autocomplete="off"
									id="password"
									required="required"
									[(ngModel)]="password"
								/>
							</div>
							<span class="c-icon c-icon-main">
								<i class="fa fa-lock" aria-hidden="true" style="font-size: 1.2em"></i>
							</span>
						</div>
						<div class="o-block__cell">
							<button class="c-button c-button--block" (click)="login()" style="margin-top: 20px">
								<span>Login</span>
							</button>
						</div>
					</div>
				</form>
				<div class="input-container">
					<div style="font-size: 0.85rem; text-transform: uppercase; text-align: center; color: #f00">
						{{ errorMessage }}
					</div>
				</div>
				<div class="input-container" id="container_forgot_password" *ngIf="!showSSOUserEmailSection">
					<div
						style="font-size: 0.95rem; text-align: center; color: #122099; cursor: pointer"
						(click)="showPasswordReset()"
					>
						Forgot Password?
					</div>
				</div>
			</div>
		</div>

		<div class="u-m-auto" *ngIf="showPasswordResetForm">
			<div
				class="c-formCard o-block u-collapse u-bg-main u-shadow-medium u-p-medium u-pt-none _u-width-100p _u-mb-small"
			>
				<div class="o-block__cell">
					<span class="c-formCard__icon c-button c-button--big c-button--icon u-radius-circle u-font-huge"
						><i class="fa fa-unlock-alt" aria-hidden="true" style="font-size: 2em"></i
					></span>
				</div>
				<div class="o-block__cell">
					<h2 class="u-font-regular loginTitle">Reset Password</h2>
				</div>
				<form>
					<div class="o-block__cell">
						<div class="c-control u-width-100p">
							<div class="c-control__input-box">
								<input
									class="c-control__input"
									name="userid"
									type="text"
									placeholder="Your Email"
									autocomplete="off"
									id="username"
									required="required"
									[(ngModel)]="username"
								/>
							</div>
							<span class="c-icon c-icon-main">
								<i class="fa fa-envelope" aria-hidden="true"></i>
							</span>
						</div>
					</div>
					<div class="o-block__cell">
						<button class="c-button c-button--block" (click)="resetPassword()" style="margin-top: 20px">
							<span>SEND ME RESET INFO</span>
						</button>
					</div>
				</form>
				<div class="input-container">
					<div style="font-size: 0.85rem; text-transform: uppercase; text-align: center; color: #f00">
						{{ errorMessage }}
					</div>
				</div>
				<div class="input-container">
					<div
						style="font-size: 0.85rem; text-align: center; color: #122099; cursor: pointer"
						(click)="hidePasswordReset()"
					>
						I know my password, Back to Login
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
